export type Route =
  | "dashboard"
  | "guida"
  | "extension"
  | "lookup"
  | "necrologi"
  | "prospects"
  | "sources"
  | "users"
  | "orgs";

export type RouteArgs = Record<string, unknown>;

export const ROUTE_TO_PATH: Record<Route, string> = {
  dashboard: "/",
  guida: "/guida",
  extension: "/estensione",
  lookup: "/lookup",
  necrologi: "/necrologi",
  prospects: "/prospect",
  sources: "/necrologi/sources",
  users: "/admin/users",
  orgs: "/admin/orgs",
};

const PATH_TO_ROUTE: Array<readonly [RegExp, Route]> = [
  [/^\/$/, "dashboard"],
  [/^\/guida\/?$/, "guida"],
  [/^\/estensione\/?$/, "extension"],
  [/^\/sessions\/?$/, "extension"], // legacy redirect
  [/^\/live\/?$/, "dashboard"], // legacy redirect
  [/^\/lookup\/?$/, "lookup"],
  [/^\/prospect\/?$/, "prospects"],
  [/^\/prospects\/?$/, "prospects"],
  [/^\/necrologi\/sources\/?$/, "sources"],
  [/^\/necrologi\/?$/, "necrologi"],
  [/^\/admin\/users\/?$/, "users"],
  [/^\/admin\/orgs\/?$/, "orgs"],
];

export function routeFromPath(path: string): Route {
  for (const [re, route] of PATH_TO_ROUTE) {
    if (re.test(path)) return route;
  }
  return "dashboard";
}

export function routeFromLocation(): Route {
  return routeFromPath(window.location.pathname);
}

export function routeArgsFromSearch(search: string): RouteArgs {
  const params = new URLSearchParams(search);
  const out: RouteArgs = {};
  params.forEach((value, key) => {
    out[key] = value;
  });
  return out;
}

export function routeArgsFromLocation(): RouteArgs {
  return routeArgsFromSearch(window.location.search);
}

export function routeTarget(route: Route, routeArgs: RouteArgs): string {
  const path = ROUTE_TO_PATH[route] ?? "/";
  const qs = new URLSearchParams();
  for (const [key, value] of Object.entries(routeArgs)) {
    if (value === undefined || value === null || value === "") continue;
    qs.set(key, String(value));
  }
  return qs.toString() ? `${path}?${qs.toString()}` : path;
}
